/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Card, Button } from "core/components";
import ProjectParticularForm from "./ProjectParticularForm";
import ProjectParticularsContext from "./ProjectParticularsContext";
import { Option } from "core/types";
import { ProjectStatus } from "core/schema";

type ProjectParticularsFormProps = {
  project: ProjectParticularsFormData;
  inventory_items: Array<Record<string, boolean>>;
  particular_types: Array<Option>;
};

const ProjectParticularsForm = ({ project, inventory_items, isLoading, particular_types }: ProjectParticularsFormProps): JSX.Element => {
  const {
    control,
    formState: { errors }
  } = useFormContext();
  const fieldArrayName = `project_tasks_attributes.[0].project_task_items_attributes`;
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldArrayName,
    keyName: "key"
  });
  const [formErrors, setFormErrors] = React.useState<Array<string>>([]);
  const [selectedItems, setSelectedItems] = React.useState<Array<TaskFormData>>([]);

  const canAppend = () => {
    return [ProjectStatus.Draft, ProjectStatus.Pending].includes(project.status);
  };

  return (
    <React.StrictMode>
      <ProjectParticularsContext.Provider value={{ selectedItems, setSelectedItems }}>
        <Card.Body>
          <Container fluid={true}>
            <Row>
              <Col>
                <h5 className="mb-4">Project Particulars</h5>
                {fields.map((item, index) => {
                  return (
                    <ProjectParticularForm
                      key={item.key}
                      index={index}
                      remove={remove}
                      project={project}
                      isLoading={isLoading}
                      inventory_items={inventory_items}
                      particular_types={particular_types}
                    />
                  );
                })}
              </Col>
            </Row>
            {canAppend() && <Button className="button--brand" title="Add Particular" onClick={() => append({ variant: "roof_color" })} />}
          </Container>
        </Card.Body>
      </ProjectParticularsContext.Provider>
    </React.StrictMode>
  );
};

export default ProjectParticularsForm;
